import { render, staticRenderFns } from "./AccountNew.vue?vue&type=template&id=01353a85&scoped=true"
import script from "./AccountNew.vue?vue&type=script&lang=js"
export * from "./AccountNew.vue?vue&type=script&lang=js"
import style0 from "./AccountNew.vue?vue&type=style&index=0&id=01353a85&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01353a85",
  null
  
)

export default component.exports